import { useContext } from 'react';
import { vehicleContext } from '../components/VehicleProvider';
import {
  BREAK_PAD_ICON,
  CHARGE_LEVEL_HALF_ICON,
  CHARGE_LEVEL_ICON,
  MOTOR_ICON,
  QUATTRO_ICON,
  TEST_DIRVE_ICON,
  TOP_SPEED_ICON,
  TRANSMISSION_ICON,
  USED_CAR_SEARCH_ICON,
  VEHICLE_SIGNAL_ICON,
} from '../constants';

const useIconFromRowName = (rowName: string): string => {
  const { market } = useContext(vehicleContext);
  const icon = market === 'cauc' ? CHARGE_LEVEL_ICON : VEHICLE_SIGNAL_ICON;

  switch (rowName) {
    case 'interior':
      return TEST_DIRVE_ICON;
    case 'exterior':
      return USED_CAR_SEARCH_ICON;
    case 'engine':
      return MOTOR_ICON;
    case 'roadTest':
      return TOP_SPEED_ICON;
    case 'tires':
      return QUATTRO_ICON;
    case 'brakes':
      return BREAK_PAD_ICON;
    case 'electrical':
    case 'driverAssist':
      return icon;
    case 'charging':
      return CHARGE_LEVEL_HALF_ICON;
    case 'transmission':
      return TRANSMISSION_ICON;
    default:
      return '';
  }
};

export default useIconFromRowName;
